import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import React from 'react';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import useIsSeller from 'hooks/useIsSeller';
import FingersCrossedImage from 'public/images/fingers-crossed.svg';
import CongratulationsImage from 'public/images/congratulations.svg';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/Congratulations.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '95%',
    height: 'auto',
    borderRadius: 10,
  },

  paperFullWidth: {
    [theme.breakpoints.up('sm')]: {
      width: '50%',
      margin: '0 auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '35%',
    },

    [theme.breakpoints.up('xl')]: {
      width: '30%',
    },
  },
}));

const noBottomMargin = { marginBottom: 0 };

const SuccessGigDialog = ({
  title,
  subtitle,
  description,
  btnText,
  fingersCrossed,
  handleCloseApplication,
}) => {
  const open = useModalOpen('Success Gig');
  const router = useRouter();
  const isSeller = useIsSeller();
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    dispatch(closeModal('Success Gig'));

    if (handleCloseApplication) {
      handleCloseApplication();
    }

    isSeller && router.push('/dashboard');
  };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      desktopDirection="up"
      direction="up"
      noCloseIcon
    >
      <div className={styles.congratulations}>
        <div className={styles.title}>
          {fingersCrossed ? <FingersCrossedImage /> : <CongratulationsImage />}

          <h3>{title.toUpperCase()}</h3>

          <h2 style={noBottomMargin}>{subtitle}</h2>

          <p>{description}</p>
        </div>

        <div className={styles.buttons}>
          <Button onClick={handleClose} variant="contained" color="primary" fullWidth>
            {btnText}
          </Button>
        </div>
      </div>
    </TransitionDialog>
  );
};

SuccessGigDialog.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  btnText: PropTypes.string.isRequired,
  fingersCrossed: PropTypes.bool,
  handleCloseApplication: PropTypes.func,
};

SuccessGigDialog.defaultPropTypes = {
  fingersCrossed: false,
  handleCloseApplication: () => {},
};

export default SuccessGigDialog;
